const validateAddress = (place, requiredState) => {
  if (typeof place === "string") {
    // The place is only ever a string when it's prefilled.  If we assume that
    // prefill URLs are only ever constructed from form data, and we only store
    // valid addresses in form data, then prefilled addresses are always valid.
    return false;
  }

  const parts = {};
  const abbrevs = {};
  if (place && place.address_components) {
    place.address_components.forEach((comp) => {
      comp.types.forEach((type) => {
        parts[type] = comp.long_name;
        abbrevs[type] = comp.short_name;
      });
    });
  }

  if (requiredState) {
    if (
      abbrevs.country !== "US" ||
      !parts.postal_code ||
      abbrevs.administrative_area_level_1 !== requiredState
    ) {
      const state = requiredState === "PA" ? "Pennsylvania" : requiredState;
      return "Enter a valid address in " + state + ".";
    }
  } else {
    if (abbrevs.country !== "US" || !parts.postal_code) {
      return "Enter a valid address in the United States.";
    }
  }
};

export default validateAddress;
